import React from "react";
import { Link } from "react-router-dom";
import { Star, PenSquare } from "lucide-react";
import Layout from "../components/Layout";
import Breadcrumbs from "../components/Breadcrumbs";
import PreFooterCTA from "../components/PreFooterCTA";
import GhlReviewsWidget from "../components/GhlReviewsWidget";
import { BUSINESS } from "../data/business";

const STAR_KEYS = ["s1", "s2", "s3", "s4", "s5"];
const BREADCRUMBS = [{ label: "Reviews" }];

function StarRow({ rating = 5, className = "w-4 h-4" }) {
  return (
    <div className="flex items-center gap-0.5 text-[#E31D2B]">
      {STAR_KEYS.slice(0, rating).map((k) => <Star key={k} className={`${className} fill-[#E31D2B]`} />)}
    </div>
  );
}

export default function Reviews() {
  return (
    <Layout>
      <section className="bg-[#1A1D21] text-white">
        <div className="abc-container py-10 md:py-14">
          <Breadcrumbs items={BREADCRUMBS} />
          <div className="mt-4 grid lg:grid-cols-12 gap-6 items-end">
            <div className="lg:col-span-8">
              <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-tight">
                What <span className="text-[#E31D2B]">Baltimore neighbors</span> are saying
              </h1>
              <p className="mt-4 text-white/80 max-w-2xl text-lg">Honest feedback from homeowners across the Baltimore and Temple Hills / DC metros — Baltimore, Glen Burnie, Clinton, Fort Washington, and nearby communities.</p>
              <p className="mt-2 text-white/55 text-xs">Live reviews straight from our Google Business Profile.</p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <Link
                to="/write-a-review"
                className="abc-btn abc-btn-accent inline-flex"
                data-testid="reviews-write-cta"
              >
                <PenSquare className="w-4 h-4" /> Write a Review
              </Link>
              <div className="text-xs text-white/50 mt-2">share your experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* Real Google reviews — GoHighLevel auto-scrolling carousel with our
          native fade-edge mask so it matches the rest of the site. */}
      <section className="py-12 md:py-16 abc-bg-pale" aria-label="Customer reviews">
        <div className="abc-container">
          <div className="flex items-end justify-between mb-6">
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-[#54616E] mb-2">Customer reviews</div>
              <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-[#1A1D21]">Rated by your neighbors across Baltimore.</h2>
            </div>
            <StarRow rating={5} className="w-5 h-5" />
          </div>
        </div>

        <div className="abc-container">
          <GhlReviewsWidget />
        </div>

        <div className="abc-container mt-10 text-center">
          <Link
            to="/write-a-review"
            className="abc-btn abc-btn-outline inline-flex"
            data-testid="reviews-write-cta-secondary"
          >
            <PenSquare className="w-4 h-4" /> Write a Review
          </Link>
          <p className="text-xs text-slate-500 mt-3">Have you worked with us? Share your experience on our <Link to="/write-a-review" className="text-[#54616E] underline hover:text-[#1A1D21]">review page</Link>, or call us at <a href={BUSINESS.phoneHref} className="text-[#54616E] underline hover:text-[#1A1D21]">{BUSINESS.phone}</a>.</p>
        </div>
      </section>

      <PreFooterCTA />
    </Layout>
  );
}
